import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTwitterComponent } from "./med-icon-twitter.component";

@NgModule({
  declarations: [
    MedIconTwitterComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTwitterComponent,
  ],
})
export class MedIconTwitterModule { }
